import React, { useEffect, useState } from "react";
import TopBar from "@/components/TopBar";
import Footer from "@/components/Footer";
import WhatsAppFAB from "@/components/WhatsAppFAB";
import Seo from "@/components/Seo";
import { Container, Reveal } from "@/components/primitives";
import { api, mediaSrc } from "@/lib/api";

const FB = {
  eyebrow: "· A QUIET REFERENCE ·",
  headline: "1.618",
  lead: "A relationship between parts. A rhythm that feels right before it can be explained.",
  image_a: "https://images.unsplash.com/photo-1724775255163-b0f5f5241642?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  p1: "Great spaces feel effortless. The eye moves through them without friction. A window is placed where a window should be. A chair sits where it belongs. A wall pauses, and then continues.",
  p2: "These decisions look intuitive. They are not. They are the result of quiet, patient attention to scale, rhythm, materiality and balance — the things you feel rather than see.",
  image_b: "https://images.unsplash.com/photo-1772442363851-738a548f6c5c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  pullquote: "We refine through proportion, rhythm and balance.\nWe complete what design begins.",
  small_mark: "· 1.618 ·",
};

export default function HiddenRatio() {
  const [doc, setDoc] = useState(null);
  useEffect(() => { api.getPage("hidden_ratio").then(setDoc).catch(() => {}); }, []);
  const c = doc?.content || {};
  const hero = c.hero || {}, body = c.body || {}, closing = c.closing || {};
  const eyebrow = hero.eyebrow || FB.eyebrow;
  const headline = hero.headline || FB.headline;
  const lead = hero.lead || FB.lead;
  const imgA = c.image_a?.image_url ? mediaSrc(c.image_a.image_url) : FB.image_a;
  const p1 = body.p1 || FB.p1, p2 = body.p2 || FB.p2;
  const imgB = c.image_b?.image_url ? mediaSrc(c.image_b.image_url) : FB.image_b;
  const pullquote = closing.pullquote || FB.pullquote;
  const smallMark = closing.small_mark || FB.small_mark;
  const ml = (t) => t.split("\n").map((line, i) => <span key={i} className="block">{line}</span>);

  return (
    <div className="min-h-screen bg-lux-bg">
      <Seo title="1.618 · Onedot6" description={lead} path="/1618" />
      <TopBar />
      <Container className="pt-40 md:pt-52 pb-24 max-w-[880px]">
        <p className="text-[11px] tracking-[0.35em] text-lux-accent font-medium">{eyebrow}</p>
        <h1 className="font-serif text-lux-ink font-light tracking-tight leading-none mt-4 text-6xl md:text-[120px]">{headline}</h1>
        <p className="font-serif italic text-lux-sec font-light leading-relaxed mt-6 text-xl md:text-2xl max-w-[720px]">{lead}</p>
        <Reveal><img src={imgA} alt="" className="w-full h-80 md:h-[520px] object-cover bg-lux-line mt-16" /></Reveal>
        <p className="font-serif text-lux-ink font-light leading-loose mt-16 text-lg md:text-xl max-w-[720px]">{p1}</p>
        <p className="font-serif text-lux-ink font-light leading-loose mt-6 text-lg md:text-xl max-w-[720px]">{p2}</p>
        <Reveal><img src={imgB} alt="" className="w-full h-80 md:h-[520px] object-cover bg-lux-line mt-16" /></Reveal>
        <p className="font-serif italic text-lux-ink font-light tracking-tight mt-16 text-2xl md:text-4xl leading-snug max-w-[880px]">{ml(pullquote)}</p>
        <p className="font-serif text-[11px] tracking-[0.35em] text-lux-muted mt-16">{smallMark}</p>
      </Container>
      <Footer />
      <WhatsAppFAB />
    </div>
  );
}
